export default {
  "widget.defaultTitle": "Chat met ons",
  "widget.defaultSubtitle": "Wij helpen u graag",
  "widget.defaultGreeting": "Hallo! Hoe kunnen we u vandaag helpen?",
  "chat.close": "Chat sluiten",
  "chat.open": "Chat openen",
  "chat.expand": "Chat vergroten",
  "chat.collapse": "Chat verkleinen",
  "chat.conversationEnded": "Dit gesprek is beëindigd",
  "chat.startNew": "Nieuw Gesprek Starten",
  "chat.poweredBy": "Mogelijk gemaakt door",
  "chat.conversationClosed": "Gesprek Gesloten",
  "chat.aiLabel": "AI-assistent",
  "input.placeholder": "Typ een bericht...",
  "input.send": "Bericht verzenden",
  "error.sendFailed": "Uw bericht kon niet worden verzonden. Probeer het zo meteen opnieuw.",
  "error.messageTooLong": "Uw bericht is te lang. Maak het korter en probeer het opnieuw.",
  "chat.teamMember": "Een teamlid",
  "chat.agentJoined": "{name} neemt deel aan de chat",
  "chat.agentLeft": "{name} heeft de chat verlaten",
  "chat.agentReturnedToAi": "{name} heeft de chat verlaten. U chat weer met de AI-assistent.",
  "availability.open": "Nu open",
  "availability.backAt": "Terug {when}",
  "availability.closed": "Nu niet bereikbaar",
  "waiting.title": "Wachten op een persoon",
  "waiting.typical": "Reageert meestal binnen {time}",
  "waiting.alerted": "We hebben het team gewaarschuwd.",
  "waiting.closed": "Het team is {when} terug. Tot die tijd kan de AI-assistent je verder helpen.",
  "waiting.minutes": "~{n} min",
  "waiting.hours": "~{n} u",
  "contact.prompt":
    "Laat je e-mailadres achter, dan sturen we het antwoord van het team daarheen als je weg bent.",
  "contact.label": "E-mail",
  "contact.placeholder": "jij@voorbeeld.nl",
  "contact.submit": "Laat het me weten",
  "contact.consent": "We gebruiken je e-mailadres alleen om op dit gesprek te reageren.",
  "contact.saved": "Bedankt! Als je weg bent wanneer het team reageert, sturen we je een e-mail.",
  "contact.failed":
    "Je e-mailadres kon niet worden opgeslagen. Controleer het en probeer het opnieuw.",
  "input.attach": "Foto of pdf bijvoegen",
  "error.fileTooLarge": "Dat bestand is te groot. Foto's en pdf's tot 10 MB.",
  "error.fileType": "Je kunt foto's (JPG, PNG, GIF, WebP) of pdf's sturen.",
  "error.fileFailed": "Je bestand kon niet worden verstuurd. Probeer een ander bestand.",
  "attachment.photo": "Foto",
  "attachment.file": "Bestand",
  "attachment.sending": "Versturen...",
  "error.verificationFailed": "We konden uw bericht niet verifiëren. Vernieuw de pagina en probeer het opnieuw.",
  "challenge.label": "Beveiligingscontrole",
  "challenge.prompt": "Een korte beveiligingscontrole voordat we uw bericht versturen.",
  "csat.defaultQuestion": "Hoe zou je de ondersteuning van vandaag beoordelen?",
  "csat.thankYou": "Bedankt voor je feedback!",
} as const;
